export class TrainingPeriodAccumulationType {
	constructor() {
	}
} 
